<template>
    <div
        class="mt-input mt-input--select"
        :class="{ disabled, active: active, filled: filled, invalid: !valid }"
        @click="onSelectClick"
    >
        <div
            v-if="coins"
            class="coins"
        >{{ coins }}</div>

        <div
            v-if="label"
            class="label"
            :class="{ 'hold-place': !filled, 'invalid': !valid }"
        >{{ label }}<span class="required" v-if="required">&nbsp;&nbsp;*</span></div>

        <template v-if="isMobile">
            <select
              :style="{ display: 'block' }"
              class="mt-input__value"
              :value="selectValue"
              @change="emitValueByHash($event)"
            >
                <option disabled :selected="selectValue === ''" value>{{ label }}</option>
                <option
                  v-for="(item, hash) in itemsMap"
                  :key='hash'
                  :value="hash"
                  :selected="selectValue === hash"
                  :disabled="disabledKeys.includes(item.id)"
                >{{item[itemText]}}</option>
            </select>
            <div class="mt-input__value__arrow"></div>
        </template>


        <template v-else>
            <input
                class="mt-input__value"
                style="pointer-events: none;"
                :class="{ disabled, invalid: !valid }"
                type="text"
                ref="input"
                readonly
                @blur="onBlur"
                @focus="inFocus = true"
                @select="clearTextSelection"
                @selectionstart="() => false"
                :value="innerValue ? innerValue[itemText] : ''"
            >
            <!-- selectionstart merge -->
            <div class="mt-input__value__arrow"></div>
            <div
                class="mt-input__select"
                v-if="!disabled && active"
            >
                <div
                    class="mt-input__select__item mt-input__value"
                    v-for="(item, index) in items"
                    :key='index'
                    @mousedown.stop="emitValue(item[itemValue])"
                    :class="{
                        selected: innerValue
                        && checkValue(item),
                        'mt-input__select_disabled': disabledKeys.includes(item.id)
                    }"
                >{{item[itemText]}}</div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import hash from 'object-hash';
const getters = [
    'isMobile',
];

export default {
    name: 'ModelSelect',
    data() {
        return {
            inFocus: false,
            active: false,
            innerValue: null,
            blur: false,
        };
    },
    methods: {
        onBlur() {
            setTimeout(() => {
                this.inFocus = false;
            }, 350);
        },
        onSelectClick(e) {
            this.$emit('click', e);
            this.inFocus = !this.active;
        },
        clearTextSelection() {
            this.$refs.input.setSelectionRange(0, 0);
        },
        openSelect() {
            this.active = true;
            if (this.$refs.input) {
                this.$refs.input.focus();
            }
        },
        closeSelect() {
            this.active = false;
            if (this.$refs.input) {
                this.$refs.input.blur();
            }
        },
        emitValueByHash(e) {
            let hashKey = '';
            if (e.target && e.target.value !== undefined) {
                hashKey = e.target.value;
            }

            let v = this.itemsMap[hashKey]
                ? this.itemsMap[hashKey][this.itemValue]
                : null;

            this.emitValue(v);
        },
        emitValue(value) {
            if (!isNaN(parseInt(value))) {
                value = parseInt(value);
            }
            if (this.innerValue && this.innerValue[this.itemValue]) {
                if (value === this.innerValue[this.itemValue]) {
                    this.active = false;
                    return;
                }
            }
            this.active = false;
            this.innerValue = this.items.find((v) => v[this.itemValue] === value);
            this.$emit('change', this.innerValue[this.itemValue]);
        },
        findValue(items, value) {
            if (items) {
                for (let i=0; i < items.length; i++) {
                    if (items[i][this.itemValue] === value) {
                        this.innerValue = items[i];
                        return;
                    }
                }
                this.innerValue = {[this.itemValue]: null, [this.itemText]: null};
            }
        },
        checkValue(item) {
            return this.innerValue ? item[this.itemValue] === this.innerValue[this.itemValue] : false;
        },
    },
    mounted() {
        if (this.value !== undefined && this.value !== null && this.items && this.items.length > 0) {
            this.findValue(this.items, this.value);
        }
    },

    computed: {
        ...mapGetters(getters),
        itemsMap() {
            return this.items.reduce((acc, v) => {
                acc[hash(v)] = v;
                return acc;
            }, {});
        },
        itemValueComp() {
            return [this.items, this.value];
        },
        filled() {
            return this.active || (
                this.innerValue
                && this.innerValue[this.itemValue] !== undefined
                && this.innerValue[this.itemValue] !== null
            );
        },
        selectValue() {
            return this.innerValue
              && this.innerValue[this.itemValue] !== undefined
              && this.innerValue[this.itemValue] !== null
                ? hash(this.innerValue)
                : '';
        },
    },

    watch: {
        inFocus(v) {
            if (v) {
                this.openSelect();
            } else {
                this.closeSelect();
            }
        },
        itemValueComp(newVal) {
            const [items, value] = newVal;
            this.findValue(items, value);
        },
    },

    props: {
        coins: Number,
        label: String,
        itemValue: {
            type: String,
            default: 'value',
        },
        itemText: {
            type: String,
            default: 'text',
        },
        items: Array,
        value: [String, Number, Boolean, Object],
        returnObject: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
        },
        disabledKeys: {
            type: Array,
            default: () => [],
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    @import '../../../styles/mrem';
    @import '../../../styles/mt';

    @import "../../../styles/variables";

    .mt-input__select {
        &_disabled {
            pointer-events: none;
            cursor: not-allowed;
        }
    }

    @media (max-width: $vm) {
        .mt-input__value {
            height: calc(100% - 2px);
            width: 100%;
            border: 0;
            appearance: none;
            background-color: #FFFFFF;

            &::-ms-expand {
                display: none;
            }

        //   .label {
        //     font-size: 12px;
        //     line-height: 16px;
        //     top: -9px;
        //     left: 14px;
        //   }

        //   .label.hold-place {
        //     top: 10px;
        //     left: 14px;
        //     color: #98a0a9;
        //     background-color: #fff;
        //     font-size: 16px;
        //   }

        //   .valueField {
        //     & + .arrow {
        //       margin-right: 15;
        //       .icon {
        //         width: 24;
        //         height: 24;
        //       }
        //     }
        //   }
      }
    }
</style>
